module.exports = __webpack_public_path__ + "static/ohNoGodzilla-bdd316f4e4e29cc40114a18f0c816102.png";